export default {
  MERGE: 'merge',
  UNMERGE: 'unmerge',
  CHILD: 'child',
  PARENT: 'parent',
  ASSIGN: 'assign',
  REMOVE: 'remove',
  EMPLOYEE: 'employee',
  STATION: 'station',
  SECTION: 'section',
};
